export default function initSpotlight() {
    const container = document.querySelector('.spotlight__container');
    const illustration = document.querySelector('.spotlight__illustration');
    const maxSpotlightSize = 150; // Maximum size of the spotlight in pixels
    const borderProximity = 100; // Distance from the border within which the spotlight grows
    let isMouseMoving = false;

    function updateSpotlight(x, y) {
        const rect = container.getBoundingClientRect();

        // Calculate distance from top and bottom edges
        const distanceToTop = y - 45;
        const distanceToBottom = rect.height - (y + 45);

        // Adjust spotlight size based on proximity to top or bottom edge
        const minDistance = Math.min(distanceToTop, distanceToBottom);
        const spotlightSize = Math.max(0, maxSpotlightSize * Math.min(minDistance / borderProximity, 1));

        const spotlightGradient = `radial-gradient(circle ${spotlightSize}px at ${x}px ${y}px, black 85%, transparent 100%)`;

        illustration.style.webkitMaskImage = spotlightGradient;
        illustration.style.maskImage = spotlightGradient;
    }

    function setDefaultSpotlight() {
        const rect = container.getBoundingClientRect();
        const x = rect.width * 0.75; // Quarter size of the width from the right
        const y = rect.height / 2; // Vertically centered
        updateSpotlight(x, y);
    }

    if (!container) return;

    container.addEventListener('mousemove', (e) => {
        isMouseMoving = true;
        const rect = container.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        updateSpotlight(x, y);
    });

    window.addEventListener('scroll', () => {
        if (!isMouseMoving) {
            setDefaultSpotlight();
        }
    });

    // Set the default spotlight position initially
    setDefaultSpotlight();
}